/**
 * Closes the open modalog when the Escape key is pressed, mirroring the
 * legacy Modalog.vue behavior for the new brand modalogs.
 *
 * The hasModalog guard matters for stable-root modalogs, which stay mounted
 * (listener included) while the overlay is hidden.
 */
import { onBeforeUnmount, onMounted } from "vue";
import { useModalogStore } from "@/stores/modalog.js";

export function useModalogEscape() {
    const modalogStore = useModalogStore();

    function handleKeydown(event) {
        if (event.key === "Escape" && modalogStore.hasModalog) {
            modalogStore.closeModalog();
        }
    }

    onMounted(() => document.addEventListener("keydown", handleKeydown));
    onBeforeUnmount(() =>
        document.removeEventListener("keydown", handleKeydown),
    );
}
